import { getLocation } from "./selectors";
import { filterEmptyValues } from "./filterEmptyValues";

const merge = (params, currentLocation = getLocation()) => {
  const existingParams = currentLocation?.query || {};

  return Object.assign({}, existingParams, params);
};

export const getNewParams = ({ params, preserve, currentLocation }) =>
  filterEmptyValues(preserve ? merge(params, currentLocation) : params);
